import { render, staticRenderFns } from "./CompanyContractorsCollectionCard.vue?vue&type=template&id=74ffc586"
import script from "./CompanyContractorsCollectionCard.vue?vue&type=script&lang=ts"
export * from "./CompanyContractorsCollectionCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74ffc586')) {
      api.createRecord('74ffc586', component.options)
    } else {
      api.reload('74ffc586', component.options)
    }
    module.hot.accept("./CompanyContractorsCollectionCard.vue?vue&type=template&id=74ffc586", function () {
      api.rerender('74ffc586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/CompanyContractorsCollectionCard.vue"
export default component.exports